import React, { Fragment } from "react"
import Header from "./header"
import Footer from "./footer"
import Wave from "./wave"
import { StyledLayout } from "./globalStyles"
import ReverseWave from "./reverseWave"
const Layout = ({ children }) => {
  return (
    <StyledLayout>
      <Wave>
        <Header />
      </Wave>
      <main id="main-content">{children}</main>
      <ReverseWave />
      <Footer />
      <div
        style={{
          position: "relative",

          width: "100%",
          background: "#060c21",
        }}
      >
        <span
          style={{
            position: "relative",
            bottom: "100px",
          }}
        >
          ©{new Date().getFullYear()} Hamzah Aldolaay
        </span>
      </div>
    </StyledLayout>
  )
}

export default Layout
